import React from 'react'
import { Flex, FlexProps } from '../Flex/Flex'

export type HStackProps = Omit<FlexProps, 'direction'>
export const HStack = (props: HStackProps) => <Flex {...props} direction="row" />
